import React from 'react';
import {ToastContainer, ToastStore} from 'react-toasts';

import ProfileSubSectionStyles from './components/ProfileSubSection.css';

export default class ChangePassword extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            oldPassword: "",
            newPassword: "",
            newPasswordAgain: "",
        }

    }

    updatePassword = () => {

        window.globalVars.server.api({
            method: "post",
            url: "/api/user/change-password",
            data: {
                oldPassword: this.state.oldPassword,
                newPassword: this.state.newPassword,
                newPasswordAgain: this.state.newPasswordAgain,
            },
            then: function(res) {

                if (res.data.success === false) {
                    ToastStore.error(res.data.data);
                } else {
                    window.location.href = "/profile"
                }

            }.bind(this),
            catch: function(e) {
                ToastStore.error("Couldn't change password");
            }.bind(this)
        })

    }

    componentDidMount() {
        window.scrollTo({top: 0, left: 0, behavior: "smooth"});
        document.title = window.globalVars.pageTitleBefore + "Change Password" + window.globalVars.pageTitleAfter;
    }

    handleChange = (name, value) => {
        let state = this.state;
        state[name] = value;
        this.setState(state);
    }

    render() {

        return (
            <div className="profile-sub-section-container">
                <div className="main-container">
                    <div className="profile-sub-section">
                        <h1>My Account</h1>
                        <section>
                            <h2>Change new password</h2>
                            <hr />
                            <div>
                                <div className="form-group">
                                    <label for="old-password">Current Password</label>
                                    <input
                                        type="password"
                                        id="old-password"
                                        name="old-password"
                                        defaultValue={ (this.state.oldPassword || "") }
                                        onChange={(e) => { this.handleChange("oldPassword", e.target.value) } }
                                    />
                                </div>
                                <div className="form-group">
                                    <label for="new-password">New Password</label>
                                    <input
                                        type="password"
                                        id="new-password"
                                        name="new-password"
                                        defaultValue={ (this.state.newPassword || "") }
                                        onChange={(e) => { this.handleChange("newPassword", e.target.value) } }
                                    />
                                </div>
                                <div className="form-group">
                                    <label for="new-password-again">Confirm Password</label>
                                    <input
                                        type="password"
                                        id="new-password-again"
                                        name="new-password-again"
                                        defaultValue={ (this.state.newPasswordAgain || "") }
                                        onChange={(e) => { this.handleChange("newPasswordAgain", e.target.value) } }
                                    />
                                </div>
                                <button onClick={() => {this.updatePassword()}}>
                                    Save
                                </button>
                            </div>
                        </section>
                    </div>
                </div>
                <ToastContainer store={ToastStore}/>
            </div>
        );

    }

}



// WEBPACK FOOTER //
// ./src/ChangePassword.js